export default __webpack_public_path__ + "static/safe-place-dc4e39322a0d0d7f3326efbb60cc115b.webm";